import dayjs from 'dayjs';
import { DealerType, DomainAttributesValues } from 'src';

export const logMessage = (e: any, label?: string) => {
	const urlParams = new URLSearchParams(window.location.search);
	if (urlParams.get('log') !== null) {
		if (label) console.info('%c' + label, 'font-weight: bold; font-size: 14px; color: #001e50;', e);
		else console.info(e);
	}
};

export const formatToTwoChars = (str: string) => {
	if (str === null || str === undefined || str === '') {
		return '';
	}

	str = String(str);

	return str.length === 1 ? '0' + str : str;
};

export const arrayToObject = (arr: DomainAttributesValues[]) => {
	if (!arr) return null;
	const obj = {};
	for (const i in arr) {
		obj[arr[i].name] = arr[i].value;
	}
	return obj;
};

export const capitalize = (text: string): string => {
	if (typeof text !== 'string' || !text) {
		return '';
	}
	return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};

export const strTitlelize = (str: string) => {
	if (!str) return '';
	return str
		.toLowerCase()
		.split(' ') // separar palabras para capitalizar
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join(' ')
		.split('.') // separar sociedades para capitalizar (S.A., S.L.U.)
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join('.');
};

export const removeParagraphTags = (htmlString: string) => {
	const regex = /<\/?p[^>]*>/g;
	return htmlString?.replace(regex, '');
};

export function underlineToMarkdownBold(text: string) {
	return text
		.replace(/^\*/, '')
		.replace(/<u>/g, '**')
		.replace(/<\/u>/g, '**')
		.replace(/<\/?[^>]+(>|$)/g, '');
}

// Para los casos como "Rioja, La" convierte en "La Rioja"
export const normalizeProvince = (str: string): string => {
	if (!str) return '';

	let cleanStr = str.trim();

	if (cleanStr.includes(',')) {
		const parts = cleanStr.split(',').map((p) => p.trim());
		cleanStr = parts.reverse().join(' ');
	}

	return cleanStr;
};

export const transformDate = (date: string, outputFormat: string, inputFormat?: string) => {
	if (inputFormat) {
		if (dayjs(date, inputFormat, true).isValid()) {
			return dayjs(date, inputFormat).format(outputFormat);
		}
	} else if (dayjs(date, 'YYYY-MM-DD', true).isValid()) {
		return dayjs(date, 'YYYY-MM-DD').format(outputFormat);
	}
	return null;
};

export const findValidDayjs = (date: string): dayjs.Dayjs | null => {
	const formats = ['YYYY-MM-DD', 'DD-MM-YYYY', 'YYYY/MM/DD', 'DD/MM/YYYY'];

	for (const format of formats) {
		const parsedDate = dayjs(date, format, true);
		if (parsedDate.isValid()) {
			return parsedDate;
		}
	}
	return null;
};

export const getFirstAndLastDayOfMonth = (monthNumber?: string, yearNumber?: string): { firstDayOfMonth: number; lastDayOfMonth: number } => {
	let firstDayOfMonth;
	let lastDayOfMonth;

	if (yearNumber && monthNumber) {
		firstDayOfMonth = Number(
			dayjs()
				.locale('es')
				.utc()
				.month(Number(monthNumber) - 1) // Months are zero indexed, so January is month 0.
				.year(Number(yearNumber))
				.startOf('month')
				.format('x'),
		);
		lastDayOfMonth = Number(
			dayjs()
				.locale('es')
				.utc()
				// .add(1, 'month')
				.month(Number(monthNumber) - 1)
				.year(Number(yearNumber))
				.endOf('month')
				.format('x'),
		);
	} else {
		firstDayOfMonth = Number(dayjs().add(1, 'day').locale('es').utc().format('x'));
		lastDayOfMonth = Number(
			dayjs()
				.locale('es')
				.utc()
				// .add(1, 'month')
				.endOf('month')
				.format('x'),
		);
	}

	return { firstDayOfMonth, lastDayOfMonth };
};

// Convierte ESP12345X -> 12345
export const sanitizeKvps = (kvps?: string) => {
	if (!kvps) return null;
	return kvps.replace(/^ESP(\d+)[A-Z]$/, '$1');
};

export const dealerTypeNumberToCode = (type?: string | number): DealerType => {
	if (!type) return null;
	if (isNaN(Number(type))) return type as DealerType;
	if (type == '1') {
		return 'vn';
	} else if (type == '2') {
		return 'ps';
	} else if (type == '10') {
		return 'vo';
	}
	return null;
};

// Para convertir "my-renting" en "My Renting"
export const formatSlugToTitle = (text?: string | null): string => {
	if (!text) return '';

	return text
		.replace(/[-_]+/g, ' ')
		.trim()
		.split(/\s+/)
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
		.join(' ');
};

// Para evitar "Nuevo Nuevo..."
export const removeConsecutiveDuplicates = (text: string): string => {
	if (!text) return '';
	return text.replace(/\b([\w-]+)(?:\s+\1\b)+/gi, '$1');
};
